import { Table, TableBody } from '@mui/material';
import { InvoiceLinesHeader } from './InvoiceLinesHeader';
import { ManualLineRow } from './ManualLineRow';
import { ManualSpendDraft } from './useManualSpendDraft';

export interface ManualLineItemsTableProps {
  draft: ManualSpendDraft;
  categories: string[];
}

export const ManualLineItemsTable = ({ draft, categories }: ManualLineItemsTableProps) => (
  <Table size="small">
    <InvoiceLinesHeader withRemove />
    <TableBody>
      {draft.lines.map((line, index) => (
        <ManualLineRow
          key={line.key}
          line={line}
          number={index + 1}
          categories={categories}
          checked={draft.checked}
          disabled={draft.saving}
          onFieldChange={draft.editField}
          onCategoryChange={draft.setCategory}
          onScopeChange={draft.setInScope}
          onRemove={draft.removeLine}
        />
      ))}
    </TableBody>
  </Table>
);
